
import { useEffect, useState } from 'react';
import { PaymentMethodType, PaymentGatewayContentProps, PaymentContentType } from '../../types/payment';
import PaymentAmount from './PaymentAmount';
import PaymentOptions from './PaymentOptions';
import PaymentForm from './PaymentForm';

export const PaymentGatewayContent = ({
  showPaymentOptions,
  showPaymentForm,
  paymentType,
  amount,
  onPayNow,
  onBankTransfer,
  onPaymentMethodChange,
  paymentMethod,
  onBankTransferReadyChange
}: PaymentGatewayContentProps) => {
  const [displayAmount, setDisplayAmount] = useState(amount);

  // Ensure we have a valid amount, even if it's passed as 0
  useEffect(() => {
    if (amount <= 0) {
      // Try to get amount from localStorage if the passed amount is 0
      const budgetCalculations = localStorage.getItem('budgetCalculations');
      if (budgetCalculations) {
        try {
          const { totalBudget } = JSON.parse(budgetCalculations);
          setDisplayAmount(parseFloat(totalBudget) || 0);
        } catch (err) {
          console.error("Error parsing budget calculations:", err);
        }
      }
    } else {
      setDisplayAmount(amount);
    }
  }, [amount]);

  return (
    <div className="space-y-6">
      {!showPaymentOptions && !showPaymentForm && (
        <PaymentAmount amount={displayAmount} />
      )}

      {showPaymentOptions && (
        <PaymentOptions 
          onPayNow={onPayNow}
          onBankTransfer={onBankTransfer}
          amount={displayAmount}
        />
      )}

      {showPaymentForm && paymentType === 'immediate' && (
        <PaymentForm
          amount={displayAmount}
          paymentMethod={paymentMethod}
          onPaymentMethodChange={onPaymentMethodChange}
          onBankTransferReadyChange={onBankTransferReadyChange}
        />
      )}
    </div>
  );
};
